export const cssVarTableHeight = '--jwm-list-height';
export const cl = {
	BASE_TABLE: 'BaseTable',
	BASE_TABLE_BODY: 'BaseTable__body',
	BASE_TABLE_TABLE: 'BaseTable__table',
	MULTIDRAG_COUNTER: 'jwm-multidrag-counter',
};

export const INDENT_PER_LEVEL = 25;
export const EXPAND_DELAY_MS = 500;
export const SUBTASK_HIERARCHY_LEVEL = -1;
